function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { createContext, useState, useEffect } from 'react';
/* eslint-disable @typescript-eslint/no-explicit-any */

var NavbarContext = createContext({
  isDark: false,
  logoUrl: '/',
  hideLogo: false,
  navItems: [],
  setNavItems: function setNavItems() {
    return null;
  },
  userMenuItems: [],
  setUserMenuItems: function setUserMenuItems() {
    return null;
  },
  notificationMenuItems: [],
  setNotificationMenuItems: function setNotificationMenuItems() {
    return null;
  },
  helpUrl: '',
  setHelpUrl: function setHelpUrl() {
    return null;
  },
  helpTarget: '',
  setHelpTarget: function setHelpTarget() {
    return null;
  },
  helpMenuItems: [],
  setHelpMenuItems: function setHelpMenuItems() {
    return null;
  },
  location: '',
  setLocation: function setLocation() {
    return null;
  },
  helpMenuLocation: '',
  setHelpMenuLocation: function setHelpMenuLocation() {
    return null;
  },
  userMenuLocation: '',
  setUserMenuLocation: function setUserMenuLocation() {
    return null;
  },
  showAlertIconBadge: false,
  setShowAlertIconBadge: function setShowAlertIconBadge() {
    return null;
  },
  notificationItemFormatter: function notificationItemFormatter() {
    return null;
  },
  setNotificationItemFormatter: function setNotificationItemFormatter() {
    return null;
  },
  noNotificationMessage: '',
  setNoNotificationMessage: function setNoNotificationMessage() {
    return null;
  },
  hasBody: false,
  setHasBody: function setHasBody() {
    return null;
  },
  hasAdditionalNavItems: false,
  setHasAdditionalNavItems: function setHasAdditionalNavItems() {
    return null;
  },
  hasNotificationMenu: false,
  setHasNotificationMenu: function setHasNotificationMenu() {
    return null;
  },
  navbarLinkWrapper: null,
  setNavbarLinkWrapper: function setNavbarLinkWrapper() {
    return null;
  },
  helpItemLinkWrapper: undefined,
  setHelpItemLinkWrapper: function setHelpItemLinkWrapper() {
    return null;
  },
  helpDropdownItemLinkWrapper: undefined,
  setHelpDropdownItemLinkWrapper: function setHelpDropdownItemLinkWrapper() {
    return null;
  },
  userMenuLinkWrapper: undefined,
  setUserMenuLinkWrapper: function setUserMenuLinkWrapper() {
    return null;
  },
  notificationMenuLinkWrapper: undefined,
  setNotificationMenuLinkWrapper: function setNotificationMenuLinkWrapper() {
    return null;
  },
  userInfo: null,
  setUserInfo: function setUserInfo() {
    return null;
  },
  dropdownsExpandedByDefault: false,
  setDropdownsExpandedByDefault: function setDropdownsExpandedByDefault() {
    return null;
  },
  appSwitcherItems: [],
  setAppSwitcherItems: function setAppSwitcherItems() {
    return null;
  },
  showMobileMenu: false,
  setShowMobileMenu: function setShowMobileMenu() {
    return null;
  },
  showMobileNotifications: false,
  setShowMobileNotifications: function setShowMobileNotifications() {
    return null;
  },
  showMobileApplicationSwitcher: false,
  setShowMobileApplicationSwitcher: function setShowMobileApplicationSwitcher() {
    return null;
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  notificationMenuOnClick: function notificationMenuOnClick() {},
  setNotificationMenuOnClick: function setNotificationMenuOnClick() {
    return null;
  },
  customMobileMenu: null,
  hideHelpMenuHeader: false,
  setHideHelpMenuHeader: function setHideHelpMenuHeader() {
    return null;
  },
  appInstancesOpen: [],
  setAppInstancesOpen: function setAppInstancesOpen() {
    return null;
  },
  appSwitcherLinkWrapper: undefined,
  setAppSwitcherLinkWrapper: function setAppSwitcherLinkWrapper() {
    return null;
  },
  launchpadUrl: '',
  setLaunchpadUrl: function setLaunchpadUrl() {
    return null;
  }
});
NavbarContext.Consumer;

var NavbarProvider = function NavbarProvider(_ref) {
  var children = _ref.children,
      isDark = _ref.isDark,
      logoUrl = _ref.logoUrl,
      hideLogo = _ref.hideLogo,
      customMobileMenu = _ref.customMobileMenu,
      isMobileMenuOpen = _ref.isMobileMenuOpen,
      onMobileMenuToggle = _ref.onMobileMenuToggle;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      navItems = _useState2[0],
      setNavItems = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      helpUrl = _useState4[0],
      setHelpUrl = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      helpTarget = _useState6[0],
      setHelpTarget = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      helpMenuItems = _useState8[0],
      setHelpMenuItems = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      userMenuItems = _useState10[0],
      setUserMenuItems = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      appSwitcherItems = _useState12[0],
      setAppSwitcherItems = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      location = _useState14[0],
      setLocation = _useState14[1];

  var _useState15 = useState(''),
      _useState16 = _slicedToArray(_useState15, 2),
      helpMenuLocation = _useState16[0],
      setHelpMenuLocation = _useState16[1];

  var _useState17 = useState(''),
      _useState18 = _slicedToArray(_useState17, 2),
      userMenuLocation = _useState18[0],
      setUserMenuLocation = _useState18[1];

  var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      notificationMenuItems = _useState20[0],
      setNotificationMenuItems = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      showAlertIconBadge = _useState22[0],
      setShowAlertIconBadge = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      showMobileNotifications = _useState24[0],
      setShowMobileNotifications = _useState24[1];

  var _useState25 = useState(isMobileMenuOpen),
      _useState26 = _slicedToArray(_useState25, 2),
      showMobileMenu = _useState26[0],
      setShowMobileMenu = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      showMobileApplicationSwitcher = _useState28[0],
      setShowMobileApplicationSwitcher = _useState28[1];

  var _useState29 = useState(null),
      _useState30 = _slicedToArray(_useState29, 2),
      notificationItemFormatter = _useState30[0],
      setNotificationItemFormatter = _useState30[1];

  var _useState31 = useState(''),
      _useState32 = _slicedToArray(_useState31, 2),
      noNotificationMessage = _useState32[0],
      setNoNotificationMessage = _useState32[1];

  var _useState33 = useState(false),
      _useState34 = _slicedToArray(_useState33, 2),
      hasBody = _useState34[0],
      setHasBody = _useState34[1];

  var _useState35 = useState(false),
      _useState36 = _slicedToArray(_useState35, 2),
      hasAdditionalNavItems = _useState36[0],
      setHasAdditionalNavItems = _useState36[1];

  var _useState37 = useState(false),
      _useState38 = _slicedToArray(_useState37, 2),
      hasNotificationMenu = _useState38[0],
      setHasNotificationMenu = _useState38[1];

  var _useState39 = useState(null),
      _useState40 = _slicedToArray(_useState39, 2),
      navbarLinkWrapper = _useState40[0],
      setNavbarLinkWrapper = _useState40[1];

  var _useState41 = useState(null),
      _useState42 = _slicedToArray(_useState41, 2),
      helpItemLinkWrapper = _useState42[0],
      setHelpItemLinkWrapper = _useState42[1];

  var _useState43 = useState(null),
      _useState44 = _slicedToArray(_useState43, 2),
      helpDropdownItemLinkWrapper = _useState44[0],
      setHelpDropdownItemLinkWrapper = _useState44[1];

  var _useState45 = useState(null),
      _useState46 = _slicedToArray(_useState45, 2),
      notificationMenuLinkWrapper = _useState46[0],
      setNotificationMenuLinkWrapper = _useState46[1];

  var _useState47 = useState(null),
      _useState48 = _slicedToArray(_useState47, 2),
      userMenuLinkWrapper = _useState48[0],
      setUserMenuLinkWrapper = _useState48[1];

  var _useState49 = useState(null),
      _useState50 = _slicedToArray(_useState49, 2),
      userInfo = _useState50[0],
      setUserInfo = _useState50[1];

  var _useState51 = useState(false),
      _useState52 = _slicedToArray(_useState51, 2),
      dropdownsExpandedByDefault = _useState52[0],
      setDropdownsExpandedByDefault = _useState52[1];

  var _useState53 = useState(null),
      _useState54 = _slicedToArray(_useState53, 2),
      notificationMenuOnClick = _useState54[0],
      setNotificationMenuOnClick = _useState54[1];

  var _useState55 = useState(false),
      _useState56 = _slicedToArray(_useState55, 2),
      hideHelpMenuHeader = _useState56[0],
      setHideHelpMenuHeader = _useState56[1];

  var _useState57 = useState([]),
      _useState58 = _slicedToArray(_useState57, 2),
      appInstancesOpen = _useState58[0],
      setAppInstancesOpen = _useState58[1];

  var _useState59 = useState(null),
      _useState60 = _slicedToArray(_useState59, 2),
      appSwitcherLinkWrapper = _useState60[0],
      setAppSwitcherLinkWrapper = _useState60[1];

  var _useState61 = useState(''),
      _useState62 = _slicedToArray(_useState61, 2),
      launchpadUrl = _useState62[0],
      setLaunchpadUrl = _useState62[1];

  useEffect(function () {
    setShowMobileMenu(isMobileMenuOpen);
  }, [isMobileMenuOpen]);
  useEffect(function () {
    onMobileMenuToggle && onMobileMenuToggle(showMobileMenu);
  }, [showMobileMenu]);
  return React.createElement(NavbarContext.Provider, {
    value: {
      isDark: isDark,
      logoUrl: logoUrl,
      hideLogo: hideLogo,
      navItems: navItems,
      setNavItems: setNavItems,
      userMenuItems: userMenuItems,
      setUserMenuItems: setUserMenuItems,
      notificationMenuItems: notificationMenuItems,
      setNotificationMenuItems: setNotificationMenuItems,
      helpUrl: helpUrl,
      setHelpUrl: setHelpUrl,
      helpTarget: helpTarget,
      setHelpTarget: setHelpTarget,
      helpMenuItems: helpMenuItems,
      setHelpMenuItems: setHelpMenuItems,
      location: location,
      setLocation: setLocation,
      helpMenuLocation: helpMenuLocation,
      setHelpMenuLocation: setHelpMenuLocation,
      userMenuLocation: userMenuLocation,
      setUserMenuLocation: setUserMenuLocation,
      showAlertIconBadge: showAlertIconBadge,
      setShowAlertIconBadge: setShowAlertIconBadge,
      notificationItemFormatter: notificationItemFormatter,
      setNotificationItemFormatter: setNotificationItemFormatter,
      noNotificationMessage: noNotificationMessage,
      setNoNotificationMessage: setNoNotificationMessage,
      hasBody: hasBody,
      setHasBody: setHasBody,
      hasAdditionalNavItems: hasAdditionalNavItems,
      setHasAdditionalNavItems: setHasAdditionalNavItems,
      hasNotificationMenu: hasNotificationMenu,
      setHasNotificationMenu: setHasNotificationMenu,
      userMenuLinkWrapper: userMenuLinkWrapper,
      setUserMenuLinkWrapper: setUserMenuLinkWrapper,
      helpItemLinkWrapper: helpItemLinkWrapper,
      setHelpItemLinkWrapper: setHelpItemLinkWrapper,
      helpDropdownItemLinkWrapper: helpDropdownItemLinkWrapper,
      setHelpDropdownItemLinkWrapper: setHelpDropdownItemLinkWrapper,
      navbarLinkWrapper: navbarLinkWrapper,
      setNavbarLinkWrapper: setNavbarLinkWrapper,
      notificationMenuLinkWrapper: notificationMenuLinkWrapper,
      setNotificationMenuLinkWrapper: setNotificationMenuLinkWrapper,
      userInfo: userInfo,
      setUserInfo: setUserInfo,
      dropdownsExpandedByDefault: dropdownsExpandedByDefault,
      setDropdownsExpandedByDefault: setDropdownsExpandedByDefault,
      appSwitcherItems: appSwitcherItems,
      setAppSwitcherItems: setAppSwitcherItems,
      showMobileMenu: showMobileMenu,
      setShowMobileMenu: setShowMobileMenu,
      showMobileNotifications: showMobileNotifications,
      setShowMobileNotifications: setShowMobileNotifications,
      showMobileApplicationSwitcher: showMobileApplicationSwitcher,
      setShowMobileApplicationSwitcher: setShowMobileApplicationSwitcher,
      notificationMenuOnClick: notificationMenuOnClick,
      setNotificationMenuOnClick: setNotificationMenuOnClick,
      customMobileMenu: customMobileMenu,
      hideHelpMenuHeader: hideHelpMenuHeader,
      setHideHelpMenuHeader: setHideHelpMenuHeader,
      appInstancesOpen: appInstancesOpen,
      setAppInstancesOpen: setAppInstancesOpen,
      appSwitcherLinkWrapper: appSwitcherLinkWrapper,
      setAppSwitcherLinkWrapper: setAppSwitcherLinkWrapper,
      launchpadUrl: launchpadUrl,
      setLaunchpadUrl: setLaunchpadUrl
    }
  }, children);
};

export { NavbarContext, NavbarProvider };